import { render, staticRenderFns } from "./pageBackground.vue?vue&type=template&id=5813b5cc&scoped=true&"
import script from "./pageBackground.vue?vue&type=script&lang=js&"
export * from "./pageBackground.vue?vue&type=script&lang=js&"
import style0 from "./pageBackground.vue?vue&type=style&index=0&id=5813b5cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5813b5cc",
  null
  
)

export default component.exports